// Common/MessageAlert.jsx
//use for form or modal feedback
import CloseIcon from "@mui/icons-material/Close";
import { Alert, IconButton } from "@mui/material";
import React from "react";

const MessageAlert = ({ severity = "info", children, onClose }) => (
  <Alert
    severity={severity}
    action={
      <IconButton aria-label="close" color="inherit" size="small" onClick={onClose}>
        <CloseIcon fontSize="inherit" />
      </IconButton>
    }
    sx={{ mb: 2 }}
  >
    {children}
  </Alert>
);

export default MessageAlert;
